/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Attachment,
    AttachmentToJSON,
    ContentItem,
    ContentItemFromJSON,
} from '../models';

export interface DownloadArticleAttachmentApiContentitemDownloadAttachmentPostRequest {
    attachment: Attachment;
}

export interface GetContentItemApiContentitemArticleIdGetRequest {
    articleId: string;
}

export interface GetContentItemImagesApiContentitemGetRequest {
    imageUrl: string;
}

/**
 *
 */
export class ContentItemApi extends runtime.BaseAPI {

    /**
     * Download Article Attachment
     */
    async downloadArticleAttachmentApiContentitemDownloadAttachmentPostRaw(requestParameters: DownloadArticleAttachmentApiContentitemDownloadAttachmentPostRequest): Promise<runtime.BlobApiResponse> {
        if (requestParameters.attachment === null || requestParameters.attachment === undefined) {
            throw new runtime.RequiredError('attachment','Required parameter requestParameters.attachment was null or undefined when calling downloadArticleAttachmentApiContentitemDownloadAttachmentPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contentitem/download-attachment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachmentToJSON(requestParameters.attachment),
        });

        return new runtime.BlobApiResponse(response) as any;
    }

    /**
     * Download Article Attachment
     */
    async downloadArticleAttachmentApiContentitemDownloadAttachmentPost(requestParameters: DownloadArticleAttachmentApiContentitemDownloadAttachmentPostRequest): Promise<any> {
        const response = await this.downloadArticleAttachmentApiContentitemDownloadAttachmentPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Content Item
     */
    async getContentItemApiContentitemArticleIdGetRaw(requestParameters: GetContentItemApiContentitemArticleIdGetRequest): Promise<runtime.ApiResponse<ContentItem>> {
        if (requestParameters.articleId === null || requestParameters.articleId === undefined) {
            throw new runtime.RequiredError('articleId','Required parameter requestParameters.articleId was null or undefined when calling getContentItemApiContentitemArticleIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contentitem/{article_id}`.replace(`{${"article_id"}}`, encodeURIComponent(String(requestParameters.articleId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentItemFromJSON(jsonValue));
    }

    /**
     * Get Content Item
     */
    async getContentItemApiContentitemArticleIdGet(requestParameters: GetContentItemApiContentitemArticleIdGetRequest): Promise<ContentItem> {
        const response = await this.getContentItemApiContentitemArticleIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Content Item Images
     */
    async getContentItemImagesApiContentitemGetRaw(requestParameters: GetContentItemImagesApiContentitemGetRequest): Promise<runtime.BlobApiResponse> {
        if (requestParameters.imageUrl === null || requestParameters.imageUrl === undefined) {
            throw new runtime.RequiredError('imageUrl','Required parameter requestParameters.imageUrl was null or undefined when calling getContentItemImagesApiContentitemGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.imageUrl !== undefined) {
            queryParameters['image_url'] = requestParameters.imageUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/contentitem`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response) as any;
    }

    /**
     * Get Content Item Images
     */
    async getContentItemImagesApiContentitemGet(requestParameters: GetContentItemImagesApiContentitemGetRequest): Promise<any> {
        const response = await this.getContentItemImagesApiContentitemGetRaw(requestParameters);
        return await response.value();
    }

}
